import { Account } from '../types';

export function resolveImportAccountSelection(
  accounts: Account[],
  preferredAccountId?: string | null,
  lastUsedAccountId?: string
): { selectedAccountId?: string; accountPreselected: boolean } {
  if (preferredAccountId && accounts.some((account) => account.id === preferredAccountId)) {
    return { selectedAccountId: preferredAccountId, accountPreselected: true };
  }

  if (preferredAccountId === null) {
    return { selectedAccountId: undefined, accountPreselected: false };
  }

  if (lastUsedAccountId && accounts.some((account) => account.id === lastUsedAccountId)) {
    return { selectedAccountId: lastUsedAccountId, accountPreselected: false };
  }

  return { selectedAccountId: accounts[0]?.id, accountPreselected: false };
}
